module.exports = __webpack_public_path__ + "static/media/snow.b3673467.svg";